export default {
  name: [],
  description: [],
  series: [],
  active: [],
  releaseZones: [],
  owner: [],
  id: [],
  created: [],
  updated: [],
  deleted: [],
  version: [],
  processedSeries: [],
}
